import React from 'react';

import { ROUTES } from '../../utils/routes';

const logo = require('../../../img/logo.svg');

const PublicHeader: React.FC = () => {
  return (
    <nav className="sticky top-0 z-[999] border-b border-gray-200 bg-white">
      <div className="flex w-full items-center justify-between px-4 py-4 md:px-6">
        <a href={ROUTES.EXTERNAL_ACCUEIL} className="flex items-center">
          <img src={logo} alt="Logo" className="h-10 md:h-12" />
        </a>
        <span className="rounded-full bg-rgpd-blue px-4 py-1.5 text-sm font-semibold text-white">
          DEMO CROISSANCE
        </span>
      </div>
    </nav>
  );
};

export default PublicHeader;
